import { Box } from "@mui/material";
import type { DateTime } from "luxon";
import React from "react";
import type { CommandCenterNurse, FloatingNursesRecData } from "../../utils/models";
import { FloatingNurseItem } from "./FloatingNurseItem";

const MemoizeFloatingNurse = React.memo(FloatingNurseItem);

interface IProps {
	nurses: CommandCenterNurse[];
	isActive: boolean;
	onSubmit: (data: FloatingNursesRecData) => void;
	onDiscard: (nurse: CommandCenterNurse) => void;
}

export const FloatingNursesList = React.memo(({ nurses, isActive, onSubmit, onDiscard }: IProps) => {
	if (!isActive) return null;

	return (
		<Box>
			{nurses.map((nurse: CommandCenterNurse) => (
				<MemoizeFloatingNurse key={nurse.id} nurse={nurse} onSubmit={onSubmit} onDiscard={onDiscard} />
			))}
		</Box>
	);
});
